export const DRINKS_MENU = [
    {
        id: "esak-series",
        label: "Esak Summer Series",
        note: "New, a selection of classic favourites for summer",
        items: [
            { name: "Salted Caramel Latte", desc: "Milk, espresso, salted caramel syrup, finished with creamy foam", price: "289" },
            { name: "Strawberry Matcha Latte", desc: "Strawberry crush, chilled milk, finished with a soft layered matcha top", price: "329" },
            { name: "Orange Espresso Spritz", desc: "Orange juice, crisp tonic water, single espresso, orange zest lift", price: "249" },
            { name: "Berry Berry Espresso", desc: "Mixed berry juice, soda, single espresso, bold berry coffee layer", price: "229" },
            { name: "Lychee Espresso Spritz", desc: "Lychee juice, crisp tonic water, single espresso, sweet lychee zest", price: "249" },
        ],
    },
    {
        id: "mocktails",
        label: "Mocktails",
        items: [
            { name: "Kiwiana Mist", desc: "", price: "299" },
            { name: "Berry Burst", desc: "", price: "309" },
            { name: "Basil Punch", desc: "", price: "309" },
            { name: "Rose Lychee", desc: "", price: "299" },
            { name: "Crimson Sunset", desc: "", price: "299" },
            { name: "Red Veil", desc: "Beetroot, orange, foam topped with hibiscus dust", price: "309" },
            { name: "Esak Shikanji", desc: "", price: "289" },
            { name: "Frozen Fruit Crush", desc: "Watermelon", price: "369" },
            { name: "Virgin Mojito", desc: "Blue lagoon / strawberry", price: "279" },
        ],
    },
    {
        id: "shakes",
        label: "Shakes",
        items: [
            { name: "Belgian Chocolate / Oreo", desc: "", price: "329" },
            { name: "Mango / Vanilla / Strawberry", desc: "", price: "309" },
            { name: "Chia Berry Chunks Shake", desc: "Mixed berries, avocado, chia seeds & milk", price: "329" },
            { name: "Biscoff Cheese Cake Shake", desc: "", price: "349" },
        ],
    },
    {
        id: "hot-coffee",
        label: "Hot Coffee",
        items: [
            { name: "Cortado", desc: "A mini cappuccino with less foam", price: "99" },
            { name: "Single Espresso", desc: "", price: "129" },
            { name: "Doppio", desc: "Double shot espresso", price: "189" },
            { name: "Macchiato", desc: "Espresso with milk foam", price: "189" },
            { name: "Classic Americano", desc: "", price: "199" },
            { name: "Café Latte", desc: "", price: "229" },
            { name: "Cappuccino", desc: "", price: "229" },
            { name: "Café Mocha", desc: "", price: "259" },
            { name: "Nutella Café Mocha", desc: "", price: "279" },
            { name: "Hot Chocolate", desc: "", price: "279" },
        ],
    },
    {
        id: "cold-coffee",
        label: "Cold Coffee",
        items: [
            { name: "Classic Iced Americano", desc: "", price: "219" },
            { name: "Iced Latte", desc: "", price: "289" },
            { name: "Café Iced Mocha", desc: "", price: "289" },
            { name: "OG Cold Coffee", desc: "", price: "309" },
            { name: "Affogato", desc: "Espresso, vanilla ice cream", price: "299" },
        ],
    },
    {
        id: "teas",
        label: "Teas",
        items: [
            { name: "Lemon Iced Tea", desc: "", price: "249" },
            { name: "Peach Fusion Iced Tea", desc: "", price: "259" },
            { name: "Matcha Latte Bubble Tea", desc: "", price: "299" },
            { name: "Taro Mix Bubble Tea", desc: "", price: "299" },
            { name: "Strawberry Bubble Tea", desc: "", price: "299" },
            { name: "Ginger Honey Lemon Green Tea", desc: "", price: "149" },
            { name: "Hibiscus / Cranberry Green Tea", desc: "", price: "169" },
            { name: "Saffron Kahwa", desc: "", price: "189" },
            { name: "Ginger Tea", desc: "", price: "189" },
            { name: "Kadak Chai", desc: "", price: "189" },
            { name: "Masala Tea", desc: "", price: "189" },
        ],
    },
    {
        id: "juices-coolers",
        label: "Juices & Coolers",
        items: [
            { name: "Cold Press Juice", desc: "Watermelon / pineapple / orange / mix", price: "249" },
            { name: "Fresh Sugarcane Juice", desc: "", price: "219" },
            { name: "Mineral Water", desc: "", price: "100" },
            { name: "Coke / Diet Coke / Sprite / Soda", desc: "", price: "169" },
            { name: "Fresh Lime Soda", desc: "Sweet / salty / mix", price: "189" },
            { name: "Tonic Water / Ginger Ale", desc: "", price: "189" },
        ],
    },
    {
        id: "energy-kombucha",
        label: "Energy & Kombucha",
        items: [
            { name: "Red Bull Energy Drink", desc: "", price: "219" },
            { name: "Red Bull Sugarfree", desc: "", price: "219" },
            { name: "Red Bull Special Edition", desc: "Red / yellow / pink", price: "219" },
            { name: "Strawberry Gingerade Kombucha", desc: "", price: "350" },
            { name: "Mango Kombucha", desc: "", price: "350" },
        ],
    },
];
